module.exports = __webpack_public_path__ + "media/images/emblems/Bellwald-851ad959ce6fca96a723af28b003206c.png";